/**
 * 공통 파일 업로드 UI — 다른 기능에서도 재사용 가능.
 *
 * - `FileUpload`        : 베이스 primitive (variant prop 으로 모든 시각 분기. 직접 사용은 특수 케이스만)
 * - `FileAttachment`    : 일반 첨부 (다중 업로드, 형식 제한 없음, 500MB)
 * - `AiFileAttachment`  : AI 첨부 UI (단건, 허용 확장자 고정, 보라 액센트, 태그·분석 중 오버레이)
 * - `AiFileUploader`    : AI 첨부 UI + 업로드·SSE 분석(useAiFileExtraction) — 양식은 경로·documentType·onResult 만 넘김
 * - `AiFileSelectField` : 파일명 상자 + 파일 선택 버튼형 AI 확인(신분증·통장 등). 분석은 AiFileUploader 와 같은 훅
 *
 * 다른 변이(ai-verifier, ai-ent-expense 등) 가 필요하면 베이스 `FileUpload` 를 variant prop 으로 직접 호출하거나,
 * 같은 패턴으로 thin wrapper 를 추가.
 */

export { default as FileUpload } from './FileUpload';
export { default as FileAttachment } from './FileAttachment';
export { default as AiFileAttachment } from './AiFileAttachment';
export { default as AiFileUploader } from './AiFileUploader';
export { default as AiFileSelectField } from './AiFileSelectField';

export type {
  FileUploadProps,
  FileUploadValidationError,
  FileUploadRejection,
} from './FileUpload';
export type { AiFileAttachmentProps } from './AiFileAttachment';
export type { AiFileUploaderProps } from './AiFileUploader';
export type { AiFileSelectFieldProps } from './AiFileSelectField';
export type { FileUploadVariant } from './styles';

// 기본 import 호환 (`import FileUpload from '.../FileUpload'`) 유지를 위한 default
export { default } from './FileUpload';
